import API_CONFIG from '@/config';
import base from '@/plugins/baseHttp';
import { createService, createModule } from '@/models/core';

const configuration = {
  name: 'realtyManagement',
  type: 'node--realty_management',
  attributes: {
    uuid: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'uuid',
    },
    title: {
      type: 'string',
      required: true,
      isArray: false,
      name: 'title',
    },
    cardTitle: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'card_title',
    },
    data: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'data',
    },
    description: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'description',
    },
    mapUrl: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'map_url',
    },
    propertyState: {
      type: 'string',
      required: false,
      isArray: false,
      name: 'property_state',
    },
    tracing: {
      type: 'string',
      required: false,
      isArray: true,
      name: 'tracing',
    },
    published: {
      type: 'boolean',
      required: false,
      isArray: false,
      name: 'published',
    },
  },
  relationships: {
    images: {
      type: 'file--file',
      required: false,
      isArray: true,
      name: 'realty_images',
    },
  },
};
export const RealtyManagementService = createService(base, configuration, API_CONFIG.API);
export const RealtyManagementModule = createModule(RealtyManagementService, true);



// WEBPACK FOOTER //
// ./src/models/realtyManagement.js